/**
 * Created by toor on 17-10-10.
 */
export default function percent(input, length) {
	return input * 100 + '%';
}


// WEBPACK FOOTER //
// ./src/modules/filter/percent.js